module.exports = "<i [attr.data-feather]=\"icon\"></i>\r\n"